"use strict";
var _a;
exports.__esModule = true;
exports.FeedbackCategories = exports.FeedbackRatingNumeric = exports.FeedbackRatingEnum = void 0;
var FeedbackRatingEnum;
(function (FeedbackRatingEnum) {
    FeedbackRatingEnum["Great"] = "\uD83D\uDE03";
    FeedbackRatingEnum["Good"] = "\uD83D\uDE42";
    FeedbackRatingEnum["Okay"] = "\uD83D\uDE10";
    FeedbackRatingEnum["Bad"] = "\uD83D\uDE41";
    FeedbackRatingEnum["Terrible"] = "\uD83D\uDE20";
})(FeedbackRatingEnum = exports.FeedbackRatingEnum || (exports.FeedbackRatingEnum = {}));
exports.FeedbackRatingNumeric = (_a = {},
    _a[FeedbackRatingEnum.Great] = 2,
    _a[FeedbackRatingEnum.Good] = 1,
    _a[FeedbackRatingEnum.Okay] = 0,
    _a[FeedbackRatingEnum.Bad] = -1,
    _a[FeedbackRatingEnum.Terrible] = -2,
    _a);
var FeedbackCategories;
(function (FeedbackCategories) {
    FeedbackCategories["Interviewer"] = "interviewer";
    FeedbackCategories["TechnicalDifficulties"] = "technical-difficulties";
    FeedbackCategories["InterviewFormat"] = "interviewer-format";
    FeedbackCategories["Timeliness"] = "timeliness";
    FeedbackCategories["InterviewQuestions"] = "interview-questions";
    FeedbackCategories["InterpersonalSkills"] = "interpersonal-skills";
})(FeedbackCategories = exports.FeedbackCategories || (exports.FeedbackCategories = {}));
//# sourceMappingURL=feedback.js.map